import type { MonthPoint } from '@hemmafixa/shared';
import type { ChartPoint } from '@hemmafixa/ui';
import { useI18n } from '@/i18n/context';

/** Month axis labels in the user's language: "okt" and "oktober 2026" */
export function useMonthPoints() {
  const { language } = useI18n();
  const locale = language === 'sv' ? 'sv-SE' : 'en-GB';
  const short = new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' });
  const long = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' });
  return (points: MonthPoint[]): ChartPoint[] =>
    points.map(({ month, value }) => {
      const date = new Date(`${month}-01T00:00:00Z`);
      return { label: short.format(date).replace('.', ''), fullLabel: long.format(date), value };
    });
}

/** Adds up the counts of the given statuses */
export function countOf<S extends string>(rows: { status: S; count: number }[], statuses: S[]) {
  return rows.filter((row) => statuses.includes(row.status)).reduce((sum, row) => sum + row.count, 0);
}
